import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { NotFoundComponent } from './frontend/404/not-found.component';

export const routes: Routes = [
  {
    path: '404',
    component: NotFoundComponent,
  },
  {
    path: 'portal',
    canActivate: [AuthGuard],
    loadChildren: () => import('./backoffice/backoffice.routes'),
  },
  {
    path: '',
    loadChildren: () => import('./frontend/frontend.routes'),
  },
  {
    path: '**',
    redirectTo: '404',
  },
];
